/**
 * @file
 */

/**
 * Hack to export all functions needed by pages in one command.
 * @todo Switch to using per page JS, allowing for better bundling.
 */
export function hackExportFnsToWindow() {
  /** @type {any} */
  const win = window;
  win.disableEmptyAnchors = disableEmptyAnchors; // Only used once. -- Arthur 2025-09-23
  win.goHome = goHome;
  win.goHere = goHere;
  win.CreateTHEADSection = CreateTHEADSection;
  win.CreateTHEADSectionGV = CreateTHEADSectionGV;
  win.setMessageOpenState = setMessageOpenState; // Only used once. -- Arthur 2025-09-23
  win.setFAQSession = setFAQSession;
  win.setInfoCenterSession = setInfoCenterSession;
  win.setLoanReportRegion = setLoanReportRegion; // Used 2 times. -- Arthur 2025-09-23
  win.TrackPSLFExternalLink = TrackPSLFExternalLink; // Used 4 times.  -- Arthur 2025-09-23
  win.sectionDisplay = sectionDisplay;
  win.checkSize = checkSize; // Only used once. -- Arthur 2025-09-23
  win.ConfirmChat = ConfirmChat; // Only used once. -- Arthur 2025-09-23
  win.hideNavBar = hideNavBar; // Used 3 times.  -- Arthur 2025-09-23
  win.IntegerEntryOnly = IntegerEntryOnly; // Used 2 times.  -- Arthur 2025-09-23
  win.ShowBannerAd = ShowBannerAd; // Used 2 times.  -- Arthur 2025-09-23
  win.CorrespondencePreferencesLink = CorrespondencePreferencesLink; // Only used once. -- Arthur 2025-09-23
  win.hideShowEye = hideShowEye;
  win.removeTabIndexResponsiveTable = removeTabIndexResponsiveTable; // Used 2 times.  -- Arthur 2025-09-23
  win.setTabIndexZero = setTabIndexZero; // Used 3 times.  -- Arthur 2025-09-23
  win.exitAlert = exitAlert; // Used 3 times.  -- Arthur 2025-09-23
  win.FSAPin = FSAPin; // Only used once. -- Arthur 2025-09-23
  win.hideShowIcon = hideShowIcon;

  //@todo Something weird with validationengine here.
  win.removeSpecialCharacters = removeSpecialCharacters;
}

// ----------------------------------------------------------------------------------------------------------
// disable anchors with empty href
// ----------------------------------------------------------------------------------------------------------
function disableEmptyAnchors() {
   $("a").each(function () {
      if ($(this).attr("href") == "") {
         $(this).removeAttr("href");
      }
   });
}

// ----------------------------------------------------------------------------------------------------------
// redirect to the "home" page
// ----------------------------------------------------------------------------------------------------------
function goHome() {
   window.location.href = "/default.aspx";
   return false;
}
// ----------------------------------------------------------------------------------------------------------
// redirect to the page requested
// ----------------------------------------------------------------------------------------------------------
function goHere(url2use) {
   var $redirectUrl = location.origin + url2use;
   window.location.href = $redirectUrl;
   return false;
}

// ----------------------------------------------------------------------------------------------------------
// datagrids don't have a thead section and so we need to create one and move the header
// information from the tbody to it.  The first tr of the tbody has the header information.
// the data is contained within td's.
// ----------------------------------------------------------------------------------------------------------
export function CreateTHEADSection(dataGridID) {

   if ($("[id$='" + dataGridID + "']").length) {
      // first see if the tr containing the header information has any classes associated with it.
      // if so they will need to be moved to new thead section
      var $class = $("[id$='" + dataGridID + "'] tbody tr:first").prop('className');
      if ($class.length > 0) {
         $("[id$='" + dataGridID + "'] tbody").before('<thead><tr class="' + $class + '"></tr></thead>');
      } else {
         $("[id$='" + dataGridID + "'] tbody").before('<thead><tr></tr></thead>');
      }

      // copy the td's from the tbody to the new thead section
      $("[id$='" + dataGridID + "'] thead tr").append($("[id$='" + dataGridID + "'] tbody tr:first td"));

      // since the header information was contained within td's we need to replace those with th's.
      // we also need to associate any classes that were present.
      $("[id$='" + dataGridID + "'] thead tr td").each(function () {
         if (this.className.length > 0) {
            $(this).replaceWith($('<th class="' + this.className + '">' + this.innerHTML + '</th>'));
         } else {
            $(this).replaceWith($('<th>' + this.innerHTML + '</th>'));
         }
      });

      // lastly we need to remove the tr in the tbody that had the header information in it.
      $("[id$='" + dataGridID + "'] tbody tr:first").remove();
   }
}

export function CreateTHEADSectionGV(gridViewID) {

   if ($("table[id*='" + gridViewID + "']").length) {

      $("table[id*='" + gridViewID + "']").each(function () {
         // first see if the tr containing the header information has any classes associated with it.
         // if so they will need to be moved to new thead section
         var $class = $("tbody:first tr:first", this).prop('className');
         if ($class.length > 0) {
            $("tbody:first", this).before('<thead><tr class="' + $class + '"></tr></thead>');
         } else {
            $("tbody:first", this).before('<thead><tr></tr></thead>');
         }

         // copy the td's from the tbody to the new thead section
         $("thead tr", this).append($("tbody:first tr:first th", this));

         // lastly we need to remove the tr in the tbody that had the header information in it.
         $("tbody:first tr:first", this).remove();

      });

   }
}

function getUrl() {
   var myHref = window.location.href;
   var pathArray;
   var url;
   // ------------------------------
   // strip off any hash symbols
   // ------------------------------
   myHref = myHref.replace("#", "");
   // ------------------------------
   // strip off any query strings
   // ------------------------------
   if (window.location.href.indexOf('?') > -1) {
      pathArray = myHref.split('?');
      url = pathArray[0];
   }
   else {
      url = myHref;
   }
   return url;
}

function setMessageOpenState(messageType) {
   var url;
   url = getUrl();
   url = url + '/setMessageOpenState';

   // ------------------------------
   // post web service
   // ------------------------------
   $.ajax({
      type: "POST",
      url: url,
      data: '{ messageType:"' + messageType + '" }',
      contentType: "application/json; charset=utf-8",
      dataType: "json"
   });

   return true;
}

function setFAQSession(parentId, pageTitle) {
   var url;
   url = getUrl();
   url = url + '/setFAQSession';

   // ------------------------------
   // post web service
   // ------------------------------
   $.ajax({
      type: "POST",
      url: url,
      data: '{ parentId:"' + parentId + '", pageTitle:"' + pageTitle + '" }',
      contentType: "application/json; charset=utf-8",
      dataType: "json"
   });
   return true;
}

function setInfoCenterSession(pageTitle) {
   var url;
   url = getUrl();
   url = url + '/setInfoCenterSession';

   // ------------------------------
   // post web service
   // -----------------------------
   $.ajax({
      type: "POST",
      url: url,
      data: '{ pageTitle:"' + pageTitle + '"}',
      contentType: "application/json; charset=utf-8",
      dataType: "json"
   });
   return true;
}

function setLoanReportRegion(region) {
   var url;

   url = getUrl();
   url = url + "/loanReport";

   $.ajax({
      type: "POST",
      url: url,
      data: '{ region:"' + region + '" }',
      contentType: "application/json; charset=utf-8",
      dataType: "json"
   });
   return true;
}

function TrackPSLFExternalLink(myLinkPage) {
   var url;

   url = getUrl();
   url = url + "/TrackPSLFExternalLink";

   $.ajax({
      type: "POST",
      url: url,
      data: '{ myLinkPage:"' + myLinkPage + '" }',
      contentType: "application/json; charset=utf-8",
      dataType: "json"
   });
   return true;
}


/**
 * dev (mylocalhost)  test or testing staging or stg or production
 * @todo Hack
 */
export function CurrentPhase() {
   var currentUrl = window.location.host;

   currentUrl = currentUrl.toUpperCase();
   if (currentUrl.indexOf("MYLOCALHOST") !== -1) {
      return "DEV";
   } else if (currentUrl.indexOf("TEST") !== -1) {
      return "TEST";
   } else if (currentUrl.indexOf("STAGING") !== -1) {
      return "STAGING";
   } else if (currentUrl.indexOf("STG") !== -1) {
      return "STAGING";
   } else {
      return "PROD";
   }
}

/**
 * @todo: Hack
 */
function isCurrentBrandISA() {
  // @ts-ignore
  return Boolean(window.isISA);
}


// ------------------------------------------------------------------------
// Hide-Show div. action-toggleClass=true:hide, false:show
// ------------------------------------------------------------------------
export function sectionDisplay(section, action) {
   var divSelected = eval("$('div[id$=" + section + "]')");
   var divHidden = eval("$('div[id$=" + section + "].ui-helper-hidden')");

   if (typeof divHidden !== 'undefined' && divHidden.length > 0) {
      // --------------------------------------------------------------------------------
      // section is currently hidden, display it if caller wants it shown
      // --------------------------------------------------------------------------------
      if (action === 'show') {
         $(divHidden).toggleClass('ui-helper-hidden', false); // remove the hidden class
      }
   }
   else {
      // --------------------------------------------------------------------------------
      // section is currently shown, hide it if caller wants it hidden
      // --------------------------------------------------------------------------------
      if (action === 'hide') {
         $(divSelected).toggleClass('ui-helper-hidden', true);  // add the hidden class
      }
   }
}

/* ------------------------------------------------------------------------------------------- */
/* The Upload File Control UFC, uses this function to check the size of files before           */
/* the borrower tries to upload the file.                                                      */
/* Returns true if file is greater than maximum size or if unable to determine due to errors.  */
/* It displays an alert if the file is greater than the max file size and sets a message.      */
/* ------------------------------------------------------------------------------------------- */
function checkSize(controlName, maxsize) {
  var cfs = checkFileSize(controlName, maxsize, isCurrentBrandISA());
   var checkFileStatus = cfs[0];
   var checkFileStatusReason = cfs[1];

   if (checkFileStatus) {
      var fuFileName = $(':input[id$="fuDataFile"]').val();
      if (fuFileName.length < 1) {
         $(':input[id$="fuDataFile"]').val("");
         return true;
      }
      var errLabel = $('[id$="lblUFCError"]');
      errLabel.text(checkFileStatusReason);
      errLabel.toggleClass('ui-helper-hidden', false);
      alert(checkFileStatusReason);
      $(':input[id$="fuDataFile"]').val("");
      return true;
   }
   return false;
}

/* ------------------------------------------------------------------------------------------- */
/* Check file size using asp:fileupload control as the input for the file name.                */
/* Returns true if file is greater than maximum size or if unable to determine due to errors. */
/* ------------------------------------------------------------------------------------------- */
function checkFileSize(ctrlName, maximumSize, isISA) {
   var fileSize = 0;
   var failReason = "";
   var failStatus = false;
   var fuFileName = eval("$(':input[id$=" + ctrlName + "]').val()");

   /* ------------------------------------------------------------------------------------------------- */
   /*  in IE, if we blank out the file upload input box, it causes another onchange event, so disregard */
   /* ------------------------------------------------------------------------------------------------- */
   if (fuFileName.length < 1) {
      failReason = "Filename is missing.";
      failStatus = false;
   }
   else {
      try {
         fileSize = eval("$(':input[id$=" + ctrlName + "]')[0].files[0].size");
         fileSize = fileSize / 1048576;
      }
      catch (e) {
         alert("Error is :" + e);
         failReason = e;
         failStatus = true;
         return [failStatus, failReason];
      }

      if (fileSize > maximumSize) {
         /*          alert("File Size exceeds maximum allowed. Size = " + fileSize.toFixed(2) + " MB");   */
         failReason = "file size exceeds the maximum allowed of " + maximumSize + " MB.";
         if (isISA) {
            failReason = failReason + "\n\n";
            failReason = failReason + "Alternatively, you may email your documentation to Servicing@knowledgefinance.com. Please allow up to 5 business days to process your documents. If we have additional questions, we will reach out to you by phone or email.";
         }
         failStatus = true;
      }
      else if (fileSize === 0) {
         failReason = "File size is zero.";
         failStatus = true;
      }
      else {
         failReason = "File upload was successful.";
         failStatus = false;
      }
   }


   return [failStatus, failReason];
}

//Display Mini-Miranda And Due-Diligence for borrower to confirm before proceeding to online chat.
function ConfirmChat() {
   var msg = 'If this account is past due, this message, from a debt collector, is an attempt to collect a debt and any information obtained will be used for that purpose.\n\nUntil the account is brought current calls and letters regarding the delinquency may continue.';
   var answer = confirm(msg);
   if (answer) {
      // ------------------------------------------------------------------------------------------
      // create session variable to let index.aspx know that this is a "valid" chat initiation
      // ------------------------------------------------------------------------------------------
      var url;
      url = getUrl();
      url = url + "/InitiateChat";

      $.ajax({
         type: "POST",
         url: url,
         data: '{ currentTime:"' + new Date() + '"}',
         contentType: "application/json; charset=utf-8",
         dataType: "json"
      });
      // ------------------------------------------------------------------------------------------
      // hide the chat button to help stop borrower from initiating multiple chat sessions concurrently
      // ------------------------------------------------------------------------------------------
      if ($("[id$='chat_slideout']").length) {
         $("[id$='chat_slideout']").hide();
      }
      // ------------------------------------------------------------------------------------------
      // pop up a new window outside of the mohela website for the chat session
      // ------------------------------------------------------------------------------------------
      window.open('/chat/index.aspx', '_blank', 'width=500,height=600,resizable=yes,toolbar=yes');
   }
   return false;
}

export function hideNavBar() {
   $(".loggedInNav").css("display", "none");
}

// --------------------------------------------------------------------------
// the mask jquery interferes with the textmode = password
// so creating this function to cover the numeric input only requirement
// for those fields where ssn might be entered.
// --------------------------------------------------------------------------
function IntegerEntryOnly(evt) {
   if (evt.charCode > 31 && (evt.charCode < 48 || evt.charCode > 57)) {
      return false;
   }
}

/**
 * @todo This should be part of a control or moved somehwere else.
 */
export function InitializeAccordions() {

   // click event for the new accordions
   $(".accordion-bar").keypress(function (e) {
      if (e.which === 13) {
         var accordionClickId = '#' + $(this)[0].htmlFor;
         $(accordionClickId).click();
      }
   });

   // set initial state of accordions
   $(".accordion-click").each(function () {
      var accordion_bar = $(this).next(".accordion-bar");
      var current_bar_text = accordion_bar.html();
      var new_bar_text
      if ($(this).prop("checked")) {
         new_bar_text = current_bar_text + "<span class='readerText'> accordion expanded</span>";
      } else {
         new_bar_text = current_bar_text + "<span class='readerText'> accordion collapsed</span>";
      }

      accordion_bar.html(new_bar_text);
   });

   // accordion click event
   $(".accordion-click").click(function () {
      var accordion_bar = $(this).next(".accordion-bar");
      var current_bar_text = accordion_bar.html();
      var new_bar_text
      if ($(this).prop("checked")) {
         $(this).attr("aria-expanded", "true");
         new_bar_text = current_bar_text.replace("collapsed", "expanded");
      } else {
         $(this).attr("aria-expanded", "false");
         new_bar_text = current_bar_text.replace("expanded", "collapsed");
      }

      accordion_bar.html(new_bar_text);
   });


   $(".messageContainer .accordion-click").each(function () {
      var accordionContent = $(this).attr("aria-controls");

      if ($(this).prop("checked")) {
         // content visible
         $(this).attr("aria-expanded", "true");
         $("#" + accordionContent).attr("aria-hidden", "false");
         $("#" + accordionContent).css("display", "block");
      } else {
         // content not visible
         $(this).attr("aria-expanded", "false");
         $("#" + accordionContent).attr("aria-hidden", "true");
         $("#" + accordionContent).css("display", "none");
      }
   });

   // accordion click event
   $(".messageContainer .accordion-click").click(function () {
      var $control = $(this);
      var isAriaExp = $control.attr("aria-expanded");
      var newAriaExp = (isAriaExp == "false") ? "true" : "false";
      $control.attr("aria-expanded", newAriaExp);

      var accordionContent = $control.attr('aria-controls');
      var isAriaHid = $("#" + accordionContent).attr('aria-hidden');
      if (isAriaHid == "true") {
         $("#" + accordionContent).attr('aria-hidden', "false");
         $("#" + accordionContent).css('display', 'block');
      } else {
         $("#" + accordionContent).attr('aria-hidden', "true");
         $("#" + accordionContent).css('display', 'none');
      }
   });
};


function ShowBannerAd(myDialogClass, maxDialogWidth) {

   $("#divBannerAd").dialog({
      dialogClass: myDialogClass,
      modal: true,
      autoOpen: true,
      title: "",
      width: "50%",
      maxWidth: 500,
      resizable: false,
      position: { my: "center", at: "center", of: window }
   });

}


function CorrespondencePreferencesLink() {
   $.ajax({
      type: "POST",
      url: "FAQPage.aspx/CorrespondencePreferencesLink",
      data: '',
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      async: false
   });
   return true;

}

// Hide/Show Eye function
function hideShowEye(myID, myIconID) {
   var myTextBox = $('[id$="' + myID + '"]');
   var myIcon = $('.' + myIconID);


   if (myTextBox.attr('type') === "password") {
      myTextBox.attr("type", "text");
      myIcon.removeClass("fa-eye-slash").addClass("fa-eye");
   } else {
      myTextBox.attr("type", "password");
      myIcon.removeClass("fa-eye").addClass("fa-eye-slash");
   }
}

// remove tabindex from responsive table
function removeTabIndexResponsiveTable() {

   $('.responsiveTable').find('[tabindex]').removeAttr("tabindex");
}

function setTabIndexZero() {
   $('table.responsiveTable.collapsed tbody tr td:first-child').each(function () {
     $(this).attr("tabindex", "0");
     $(this).attr("role", "button");
     $(this).attr("aria-expanded", "false");
     $(this).attr("aria-label", "Show Details");
   });

  $('table.responsiveTable.collapsed tbody tr td:first-child').click(function () {
    if ($(this).attr("aria-expanded") == "true") {
      $(this).attr("aria-expanded", "false");
    }
    else if ($(this).attr("aria-expanded") == "false") {
    $(this).attr("aria-expanded", "true");
    }
  })
}


function exitAlert(linkName) {
  var str;

  str = 'By clicking on this link you will leave the MOHELA website and proceed to the selected site. MOHELA is not affiliated with '
    + linkName + ' nor does it endorse its sponsor(s) nor any of the policies, activities, products or services offered on the site or any advertiser or other sponsor on the site. By selecting the '
    + linkName + ' site, you will be entering into a third party site. In addition, MOHELA is not responsible in any way for, nor does it endorse, the web site, its content, privacy policy or level of security.'

  alert(str);
}

function FSAPin() {
  var str;

  str = 'You are about to access Federal Student Aid’s online application process. To complete your request, you will need your FSA ID Username.'
    + 'https://StudentAid.gov';

  return confirm(str);
}

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// custom.HelperUtils.js


// ****************************************************************
// hideShowIcon
//
// Setup the click event for the hide/show icon.  This includes
// setting the title (tooltip) text.
//
// Assumptions:
// The class "loan-detail-table" is applied to the table containing
// the repeater or other data control.
// ****************************************************************
function hideShowIcon() {
  // handle the show/hide icon
  $('.loan-detail-table .toggle-button').click(function () {
    var tbody = $(this).closest('tbody');
    tbody.toggleClass('open');
    if (tbody.is('.open')) {
      $(this).text('Hide Details').attr('title', 'Hide Details');
    }
    else {
      $(this).text('Show Details').attr('title', 'Show Details');
    }
    return false;
  });
}


// Currency related functions

export function formatCurrency(num) {
  num = isNaN(num) || num === '' || num === null ? 0.00 : num;
  return parseFloat(num).toFixed(2);
}



// ----------------------------------------------------------
// Remove Special Characters from string
//  removes the following characters from the variable passed
//    space
//    dash
//    forward slash
//    left paren
//    right paren
//    comma
// ----------------------------------------------------------
function removeSpecialCharacters(string2replace) {
  string2replace = string2replace.replace(/[ ,\-\/\(\)]/g, '');
  return string2replace;
}
